import React from "react";
import Image from "components/image";
import Link from "helpers/link";
import getModulePadding from "helpers/get-module-padding";

const imageSize = (length) => {
    if (!length) return "max-w-[345px]";

    return length > 1 ? "max-w-[345px]" : "max-w-[500px]";
};

const CollectionSizeGuide = ({ data }) => (
    <div className="container">
        <div className={`flex flex-col text-blue-700 ${getModulePadding()}`}>
            <h2 className="mb-4"> 
                {data?.title}
            </h2>
            <h3 className="mb-4 font-normal"> 
                {data?.subtitle}
            </h3>
            <div className="flex flex-wrap justify-evenly">
                {data?.sizeTypes?.map((sizeType) => (
                    <div key={sizeType?.description} className={imageSize(data?.sizeTypes?.length)}>
                        <div className="flex flex-col items-center">
                            <p className="font-medium"> 
                                {sizeType?.height}
                            </p>
                            <div className={imageSize(data?.sizeTypes?.length)}>
                                <Image image={sizeType?.image?.asset} />
                            </div>
                            <p className="mb-2 text-center"> 
                                {sizeType?.description}
                            </p>
                            <div className="flex flex-col gap-2 items-center">
                                <p className="font-medium w-fit">
                                    {sizeType?.sizes?.title}
                                </p>
                                {sizeType?.sizes?.links?.map((size) => (
                                    <Link key={size?.url} className="underline text-base w-fit" to={size?.url}>
                                        {size?.link} 
                                    </Link>
                                ))} 
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export default CollectionSizeGuide;
